import React from "react";
import { useTranslation } from "react-i18next";
import Avatar from 'react-avatar';
import Dropdown from "../../../../../components/Dropdown";
import Button from "../../../../../components/Button";
import ElipsisText from "../../../../../components/ElipsisText";
import { VALIDATION_FIELD_MAPPING } from "../../../../../utils/appConstant";
import { AddEdit as AddEditInterface } from "../../../../../interfaces/property.interface";

interface UsersTabProps {
  options: any[];
  allOptions: any[];
  dropdownSearchData: any
  formData: AddEditInterface;
  loading?: boolean;
  users?: any[];
  view: boolean;
  edit: boolean;
  onAssignUser: (id: string) => void;
  onRemoveUser: (id: string) => void;
  onDropdownSearchChange: (e: any, name: string) => void;
  onInputChange: (e: any, name: string) => void;
}

const UsersTab: React.FC<UsersTabProps> = ({
  options,
  allOptions,
  dropdownSearchData,
  formData,
  loading,
  users,
  view,
  edit,
  onAssignUser,
  onRemoveUser,
  onDropdownSearchChange,
  onInputChange
}) => {
  const { t } = useTranslation();

  return (
    <div className="card-body">
      {
        !view && (
          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <Dropdown
                id={VALIDATION_FIELD_MAPPING.user}
                name={VALIDATION_FIELD_MAPPING.user}
                values={formData.user && formData.user.toString().trim() ? [formData.user] : []}
                options={(options || []).map((option: any) => ({
                  label: option.name,
                  value: option.id,
                }))}
                allOptions={(allOptions || []).map((option: any) => ({
                  label: option.name,
                  value: option.id,
                }))}
                label={t('property.addEdit.pageTexts.form.users.label')}
                placeholder={t('property.addEdit.pageTexts.form.users.placeholder')}
                searchText={dropdownSearchData.user}
                onSearch={onDropdownSearchChange}
                onChange={onInputChange}
              />
            </div>
            <div className="col-md-2">
              <Button
                icon={<i className="ri-add-line ri-24px"></i>}
                className="btn btn-primary h-100 p-3"
                disabled={loading || !formData.user}
                loading={loading}
                onClick={() => onAssignUser(formData.user || '')}
              />
            </div>
          </div>
        )
      }

      {!view && users && users.length > 0 && <hr className="my-6" />}

      <div className="row g-4">
        {
          view && (!users || !users.length)
          ?
            (
              <p className="dataTables_empty text-center">{t("property.addEdit.pageTexts.noUserAssigned")}</p>
            )
          :
            (users || []).map((user: any) => {
              return (
                <div className="col-md-3" key={user.id}>
                  <div className="card">
                    <div className="row g-0">
                      <div className="col-md-4">
                        <Avatar className="card-img card-img-left w-100 h-100" name={`${user.first_name} ${user.last_name}`} maxInitials={2} />
                      </div>
                      <div className="col-md-8">
                        <div className="card-body">
                          {
                            edit && (
                              <Button
                                icon={<i className="ri-delete-bin-6-line ri-20px text-danger"></i>}
                                className="btn btn-sm position-absolute end-10 top-10 shadow-none border-0 p-0"
                                onClick={() => onRemoveUser(user.assignment_id)}
                              />
                            )
                          }
                          <ElipsisText
                            text={`${user.first_name} ${user.last_name}`}
                            width="93%"
                            className="h5 card-title"
                          />
                          <ElipsisText
                            text={user.role}
                            width="100%"
                            className="p card-text"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
        }
      </div>
    </div>
  )
};

export default UsersTab;